import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export const useQueryGetCancellationReasonList = ({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) =>
  useQuery({
    queryKey: clubQueryKeys.getCancellationReasonList(clubId),
    queryFn: async () =>
      (await api.clubApi.getCancellationReasonList(clubId)).data,
  });
